import React from 'react';
import { FormHelperText } from '@material-ui/core';
import { getDateTranspositionSuggestion } from './dateTransposition';

/**
 * Advisory, non-blocking warning shown under a date field when the entered
 * value looks like a month/day transposition. Renders nothing when the date
 * looks fine.
 *
 * @param {object} props
 * @param {string|import('moment').Moment|Date} props.value - Date to evaluate;
 *   accepts a moment object, a Date object, or a 'YYYY-MM-DD' string.
 * @returns {React.ReactElement|null}
 */
function DateInputWarning({ value }) {
  const suggestion = getDateTranspositionSuggestion(value);
  if (!suggestion) return null;

  return (
    <FormHelperText
      role="alert"
      style={{ color: '#b26a00', display: 'flex', alignItems: 'center' }}
    >
      Did you mean {suggestion}? The month and day may be swapped.
    </FormHelperText>
  );
}

export default DateInputWarning;
